<template>
  <div class="">
    <div v-if="errorMessage" class="mx-auto mt-8 max-w-lg text-left" role="alert">
      <p>{{ errorMessage }}</p>
      <button
        v-if="canRetry"
        type="button"
        class="mt-4 rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        @click="loadThumbnails"
      >
        Try again
      </button>
    </div>
    <automatic-submission-accepted v-else-if="automatic_accepted" />
    <loading v-else-if="automatic_loading"  :name="name" />
    <div v-else>
    <div  class="flex flex-wrap -mx-2 space-y-4 md:space-y-0" >
      <div class="mt-8 mx-auto max-w-7xl">
        <div class="text-center w-full h-auto">
          <h1
            class="
              text-2xl
              tracking-tight
              font-extrabold
              text-gray-900
              md:text-3xl
            "
          >
            <span class="block">Are you shown -</span>
            <span class="text-mygrad">in these thumbnails?</span>
          </h1>
        </div>
      </div>
    </div>
    <div class="mt-4 mx-auto py-2 max-w-7xl w-full" v-if="thumbnails.length">
      <div class="text-center">
        <button
          @click="notFoundButtonClick"
          type="submit"
          class="
            inline-flex
            items-center
            px-4
            py-2
            border border-gray-300
            shadow-sm
            text-sm
            font-medium
            rounded-md
            text-gray-700
            bg-white
            hover:bg-gray-50
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-indigo-500
            disabled:opacity-50!important
          "
        >
          I cannot see myself
        </button>
      </div>
    </div>
    <div
      class="max-w-2xl mx-auto py-4 px-4 sm:py-4 sm:px-6 lg:max-w-7xl lg:px-8"
    >
      <div
        class="
          grid grid-cols-1
          gap-y-10
          sm:grid-cols-2
          gap-x-6
          lg:grid-cols-3
          xl:gap-x-8
        "
      >
        <single-thumbnail
          v-for="(thumbnail, index) in thumbnails"
          :key="thumbnail.hash"
          :preview-number="index + 1"
          :confidence="thumbnail.confidence"
          :src="thumbnail.thumbnail"
          :gifSrc="thumbnail.gif"
          :url="thumbnail.url"
          :hash="thumbnail.hash"
          @clickThumbnail="clickThumbnail($event)"
        />
      </div>
    </div>
    <div class="mt-4 mx-auto py-2 max-w-7xl w-full" v-if="thumbnails.length">
      <div class="text-center">
        <button
          @click="notFoundButtonClick"
          type="submit"
          class="
            inline-flex
            items-center
            px-4
            py-2
            border border-gray-300
            shadow-sm
            text-sm
            font-medium
            rounded-md
            text-gray-700
            bg-white
            hover:bg-gray-50
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-indigo-500
            disabled:opacity-50!important
          "
        >
          I cannot see myself
        </button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import AutomaticSubmissionAccepted from "../AutomaticSubmissionAccepted.vue";
import SingleThumbnail from "./SingleThumbnail.vue";
import axios from "axios";
import Auth from "../../api/auth";
import Loading from '../Loading.vue';
import {trackEvent} from "../../Analytics.vue"
export default {
  components: { SingleThumbnail, AutomaticSubmissionAccepted, Loading },
  name: "Thumbnails",
  created() {
    this.loadThumbnails();
  },
  methods: {
    loadThumbnails() {
      this.errorMessage = "";
      this.canRetry = false;
      const id = this.$route.params.id;
      // Match the API's UUIDv4 contract before issuing a request.
      if (typeof id !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(id)) {
        this.errorMessage = "This registration link is incomplete or invalid. Please reopen the link in your email.";
        return;
      }
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + Auth.getPublicRequestToken();
      return axios
        .get(`/registrations/${id}/thumbnails`)
        .then(({ data }) => {
          this.thumbnails = data.predictions;
          this.name = data.registration.name;
          this.default_url = { path: `/submission/${data.registration.id}` };
          this.registration = data.registration;
        })
        .catch(this.handleRequestError);
    },
    handleRequestError(error) {
      this.automatic_loading = false;
      const response = error && error.response;
      const fallback = response && response.data && response.data.url;
      // The API can send a graduate to the editor when previews aren't ready.
      // Missing URLs previously became a relative "undefined" navigation loop.
      if (typeof fallback === "string") {
        try {
          const target = new URL(fallback, window.location.origin);
          if (target.origin === window.location.origin && target.pathname === `/submission/${this.$route.params.id}`) {
            this.$router.replace(target.pathname + target.search + target.hash);
            return;
          }
        } catch (e) { /* An invalid fallback is handled on this page. */ }
      }
      if (response && response.status === 404) {
        this.errorMessage = "We couldn't find previews for this registration. Please reopen the link in your email or contact support.";
        this.canRetry = false;
      } else {
        this.errorMessage = "We couldn't load your previews. Please check your connection and try again, or contact support if this continues.";
        this.canRetry = true;
      }
    },
    notFoundButtonClick() {
      trackEvent(this.$route.path, {label: "THUMBNAIL_NOT_FOUND_CLICK", registration_id: this.$route.params.id})
      this.$router.push(this.default_url);
    },
    clickThumbnail(hash_string) {
      var reg_id = this.$route.params.id;
      const thumbnail = this.thumbnails.find((item) => item.hash === hash_string);
      this.automatic_loading = true;
      trackEvent(this.$route.path, {label: "THUMBNAIL_CLICK", registration_id: reg_id, hash_string: hash_string})
      return axios
      .post(`/registrations/${reg_id}/submissions/automatic`, {
        phrase: hash_string,
        boundary_policy_revision: thumbnail?.boundary_policy_revision ?? null
      })
      .then((response) => (response.data, (this.automatic_accepted = true, this.automatic_loading=false), trackEvent(this.$route.path, {label: "THUMBNAIL_CLICK_SUCCESS", registration_id: reg_id, hash_string: hash_string})))
      .catch((error) => {
        trackEvent(this.$route.path, {label: "THUMBNAIL_CLICK_FAILED", registration_id: reg_id, hash_string: hash_string})
        this.handleRequestError(error);
      });
    }
  },
  data: function () {
    return {
      thumbnails: [],
      name: "",
      default_url: "",
      registration: {},
      automatic_accepted: false,
      automatic_loading: false,
      errorMessage: "",
      canRetry: false
    };
  },
};
</script>
